import styled from 'styled-components';

import { Button, Box } from 'grommet';

const StyledCalendarContainer = styled(Box)`
  background: ${({ $bgColor }) => $bgColor ?? 'var(--page-modal-bg)'};
  color: ${({ $primaryText }) => $primaryText ?? 'var(--page-modal-text)'};
  border-radius: var(--app-radius);

  .rdp-root {
    --rdp-accent-color: ${({ $buttonHighlight }) => $buttonHighlight ?? 'var(--page-highlight)'};
    --rdp-selected-border: ${({ $buttonHighlight }) => $buttonHighlight ?? 'var(--page-highlight)'};
    --rdp-today-color: ${({ $todayHighlight }) => $todayHighlight ?? 'var(--page-highlight)'};
    --rdp-selected-border: ${({ $borderHighlight }) => `2px solid ${$borderHighlight}` ?? '2px solid var(--page-highlight)'};
    --rdp-day-height: 2.4rem;
    --rdp-day-width: 2.4rem;
    --rdp-range_middle-background-color: ${({ $selectBg }) => ($selectBg ? `${$selectBg}` : 'var(--button-select-bg)')};
  }
`;

const StyledTimeInput = styled.input`
  padding: 0.5rem 1rem;
  font-size: 0.85rem;
  border: 1px solid ${({ $inputBorder }) => $inputBorder ?? 'var(--page-input-border)'};
  border-radius: var(--app-radius);
  color: ${({ $primaryText }) => $primaryText ?? 'var(--page-input-text)'};
  background: ${({ $bgColor }) => $bgColor ?? 'var(--page-input-bg)'};
  outline: none;

  &:focus {
    border-color: ${({ $focusHighlight }) => $focusHighlight ?? 'var(--page-focus-highlight)'};
  }
`;

const StyledCalendarSelect = styled.select`
  font-size: 0.9rem;
  border: none;
  border-radius: var(--app-radius);
  color: ${({ $primaryText }) => $primaryText ?? 'var(--page-input-text)'};
  background: ${({ $bgColor }) => $bgColor ?? 'var(--page-input-bg)'};
  outline: none;

  ::picker-icon {
    color: ${({ $buttonHighlight }) => $buttonHighlight ?? 'var(--page-highlight)'};
  }
`;

const StyledDropMenu = styled(Button)`
  padding: 0.5rem;
  font-size: 0.8rem;
  text-align: center;

  ${({ selected, highlightText }) => (selected ? `
     background: ${highlightText || 'var(--page-highlight)'};
     color: var(--button-primary-text);
    ` : `
     &:hover {
       color: ${highlightText || 'var(--page-highlight)'};
     }
  `)};
`;

export {
  StyledDropMenu,
  StyledCalendarContainer,
  StyledCalendarSelect,
  StyledTimeInput,
};
